export const NAVIGATION_BACK = 'specialty-navigation-back';

export function triggerNavigationBack() {
  window.dispatchEvent(new Event(NAVIGATION_BACK));
}

export function onNavigationBack(handler: () => void) {
  window.addEventListener(NAVIGATION_BACK, handler);
  return () => window.removeEventListener(NAVIGATION_BACK, handler);
} 